import {
  InputDataInfoType,
  InputDataPageType,
  InputDataType,
} from '@atlas-frontend/sdk';
import { useEffect, useMemo } from 'react';

const EMPTY_CONTENT: InputDataPageType['content'] = [];
const EMPTY_SUBJECT_NAME_MAPPINGS: InputDataPageType['subjectNameMappings'] =
  {};

interface UseInputDataPageOptions {
  info: InputDataInfoType;
  page?: InputDataPageType;
  setPaginationTotal: (total: number) => void;
  setRowsTotal?: (total: number) => void;
}

export function useInputDataPage({
  info,
  page,
  setPaginationTotal,
  setRowsTotal,
}: UseInputDataPageOptions) {
  const content = page?.content ?? EMPTY_CONTENT;
  const subjectNameMappings =
    page?.subjectNameMappings ?? EMPTY_SUBJECT_NAME_MAPPINGS;
  const totalElements = page?.totalElements ?? 0;
  const detailsData = useMemo<InputDataType>(
    () => ({
      columns: info.columns,
      labels: info.labels,
      rows: content,
      versionStatusId: info.versionStatusId,
      calculationTime: info.calculationTime,
    }),
    [content, info],
  );

  useEffect(() => {
    setPaginationTotal(totalElements);
    setRowsTotal?.(totalElements);
  }, [setPaginationTotal, setRowsTotal, totalElements]);

  return { detailsData, subjectNameMappings };
}
